import React, { useState, useEffect }  from 'react';
import Style from '../styles/pages/Booking.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';
import { Booking } from '../utils/Interface';
import { RootState } from '../store/GlobalStore'
import arrow from '../shared/images/arrow-down.svg'
import arrowLeft from '../shared/images/icon-arrow-left.svg'
import calendar from '../shared/images/Icon awesome-calendar-alt.svg'
import plus from '../shared/images/Icon awesome-plus-square.svg'
import pin from '../shared/images/Icon ionic-md-pin.svg'
import people from '../shared/images/Icon material-people.svg'
import { useTranslation } from 'react-i18next';
import { Box, Typography, List, ListItem } from '@mui/material'
import { useGetFicheHebergementQuery, useUpdateBookingAttributionMutation } from '../services/ReservationAPI';
import { useDispatch } from 'react-redux';
import { setReservations } from '../store/slices/authSlice';


const BookingDetailPage: React.FC = () => {
    const dispatch = useDispatch();
    const { id } = useParams<{ id: string }>();
    const [updateAttribution, { isLoading: isUpdating }] = useUpdateBookingAttributionMutation();
    const [showAttribution, setShowAttribution] = useState(false);
    const [attribution, setAttribution] = useState<string>('');
    const { t, i18n  } = useTranslation();
    const authState = useSelector((state: RootState) => state.Auth)
    const options : Intl.DateTimeFormatOptions   = { 
        weekday: 'short', // Utiliser "short", "long", ou "narrow"
        year: 'numeric',  // Utiliser "numeric" ou "2-digit"
        month: 'short',   // Utiliser "numeric", "2-digit", "long", "short", ou "narrow"
        day: 'numeric'    // Utiliser "numeric" ou "2-digit"
      };
     const navigate = useNavigate()
     const [startDate, setStartDate] = useState<string>('')
     const [endDate, setEndDate] = useState<string>('')
     const [ressource, setRessource] = useState<string>('')
     const [totalPrice, setTotalPrice] = useState<number>(0)
     const [asterioId, setAsterioId] = useState<number>(0)
     const [bookingData, setBookingData] = useState<Booking>({
        id : 0,
        bookingId: 0,
        ressource: "",
        ressourceNumber: "",
        ressourceLabel: "",
        ressourceTypeCode: "",
        ressourceTypeLabel: "",
        startDate: "",
        endDate: "",
        segmentId: 0,                   
        segmentationCode: "",
        segmentationLabel: "",
        subSegmentationCode: "",
        subSegmentationLabel: "",
        cancelled: false,
        nbGuest: 0,
        nbAdults: 0,
        nbChilds: 0,
        forfaitCode: "",
        displayImage: "",
        checkIn: "",
        checkOut: "",
        roomCode: ""
    });

    const {data: FicheHebergementData, refetch} = useGetFicheHebergementQuery(ressource || "");

    // Helper function to format time
    const formatTime = (timeString: string | undefined) => {
        if (!timeString) return '';
        // Assuming timeString is in "HH:mm:ss" format
        return timeString.substring(0, 5);
    };

    function calculerNombreDeNuits(dateDebutStr: string , dateFinStr: string) {
        // Convertir les chaînes de date en objets Date
        const dateDebut = new Date(dateDebutStr);
        const dateFin = new Date(dateFinStr);
      
        // Calculer la différence en millisecondes
        const differenceEnMs: number = (dateFin.getTime() - dateDebut.getTime());
      
        // Convertir la différence en jours
        const nombreDeJours = differenceEnMs / (1000 * 60 * 60 * 24);
      
        // Soustraire 1 pour obtenir le nombre de nuits
        const nombreDeNuits = nombreDeJours;
      
        return nombreDeNuits;
      }

      const getForfaitCode = (bookings : any, ressourceTypeCode : string) => {
        console.log(ressourceTypeCode)
        const similarBooking = bookings.find(
            (booking : any) => booking.ressourceTypeCode === ressourceTypeCode  && booking.forfaitCode && booking.forfaitCode !== ''
        );
        return similarBooking ? similarBooking.forfaitCode : null;
    };

    useEffect(() => {
        if (authState?.reservations && authState.reservations.length > 0){
            for(let j=0; j<authState?.reservations.length ; j++){
                const bookings = authState.reservations[j]?.Bookings;
                if (!bookings) continue;
                

                for(let i=0; i <bookings.length; i++){
                    const currentBooking = bookings[i];

                    if (Number(currentBooking.bookingId) === Number(id)) {
                        let forfait = '';
                        if (currentBooking?.forfaitCode === '') {
                            forfait = getForfaitCode(authState?.reservations[j]?.Bookings, currentBooking?.ressourceTypeCode);
                        } 
                        else {
                            forfait = currentBooking?.forfaitCode;
                        }
                    setBookingData(authState?.reservations[j]?.Bookings[i])
                    setRessource(authState?.reservations[j]?.Bookings[i].ressourceTypeCode)

                 
                    if (currentBooking.attribution) {
                        setAttribution(currentBooking.attribution);
                    }
                    
                    //setStartDate(new Date(authState?.reservations[j]?.Bookings[i].startDate).toLocaleDateString('fr-FR', options))
                    //setEndDate(new Date(authState?.reservations[j]?.Bookings[i].endDate).toLocaleDateString('fr-FR', options))
                    setStartDate(new Date(authState?.reservations[j]?.Bookings[i].startDate).toLocaleDateString(i18n.language, options));
                    setEndDate(new Date(authState?.reservations[j]?.Bookings[i].endDate).toLocaleDateString(i18n.language, options));
                    setAsterioId(Number(authState?.reservations[j]?.asterioId));
                    const nights = calculerNombreDeNuits(authState?.reservations[j]?.Bookings[i].startDate, authState?.reservations[j]?.Bookings[i].endDate);
                    const foilio = authState?.reservations[j]?.Folios.find(item => item.productCode === forfait);
                    const unitPrice = foilio ? foilio.unitPrice : null;
                    setTotalPrice(Number(unitPrice) * Number(nights));

                    break;

                    
                    }
                }
            }
        }

        /*if(bookingData.id === 0){
            navigate('/mon-compte') 
        }*/
    }, [authState.reservations, i18n.language,id]);

    useEffect(() => {
        if (ressource) {
            refetch();
        }
    }, [ressource, refetch]);

    const handleSaveAttribution = async () => {
        if (!id || !authState?.reservations) return;
        try {
            await updateAttribution({ 
                bookingId: Number(id), 
                attribution: attribution 
            }).unwrap();

            setBookingData(prev => ({ ...prev, attribution: attribution }));
            const updatedReservations = authState.reservations.map(res => ({
                ...res,
                Bookings: res.Bookings.map(b => 
                    Number(b.bookingId) === Number(id) 
                    ? { ...b, attribution: attribution } 
                    : b
                )
            }));
            dispatch(setReservations(updatedReservations));

            setShowAttribution(false);
        } catch (err) {
            alert("Erreur lors de la sauvegarde");
        }
    };

    return (
        <div className={Style.AnimationContainer}>
            <div className={Style.TopContainer}>
                <Link to={`/all-reservations`}>
                    <button className={Style.arrowButton}>
                        <img src={arrowLeft} alt='Arrow Left' />
                    </button>
                </Link>

                <div className={Style.HeaderFlex}>
                    <div className={Style.TitleGroup}>
                        <h2>{bookingData.ressourceLabel}</h2>
                     
                        <div className={Style.AttributionRow}>
                            {!showAttribution && attribution && (
                                <span className={Style.AttributionDisplay}>{attribution}</span>
                            )}
                            <button 
                                type="button" 
                                className={Style.ToggleAttribution}
                                onClick={() => setShowAttribution(!showAttribution)}
                            >
                                {showAttribution ? "- Fermer" : "+ Attribution"}
                            </button>
                        </div>
                    </div>
        
                    {showAttribution && (
                        <div className={Style.AttributionBlock}>
                            <div className={Style.InputWrapper}>
                                <input 
                                    name="attribution"
                                    type="text" 
                                    maxLength={50}
                                    placeholder="Ex: Claire"
                                    value={attribution}
                                    onChange={(e) => setAttribution(e.target.value)}
                                    className={Style.AttributionInput} 
                                />
                                <button 
                                    type="button"
                                    onClick={handleSaveAttribution}
                                    disabled={isUpdating}
                                    className={Style.SendButton}
                                >
                                    {isUpdating ? '...' : t('send')} 
                                </button>
                            </div>
                            <span className={Style.CharCounter}>
                                {attribution.length} / 50
                            </span>
                        </div>
                    )}
                </div>
            </div>
            
            <form className={Style.ModifyLesseeForm}>
                <div className={`${Style.ModifyLesseeFormChild}`}>
                <div className={`${Style.DesktopFormField} ${Style.Resa}`}>
                        <div className={`${Style.InputContainer} ${Style.ResaNumber}`}>
                            <div className={Style.Label}>{t('resa_num')}</div>
                            <div className={Style.Data}>{asterioId}</div>
                        </div>
                        <div className={`${Style.InputContainer} ${Style.KeyCode}`}>
                            <div className={Style.Label}>{t('key_code')}</div>
                            <div className={Style.Data}>{bookingData.roomCode}</div>
                        </div>
                    </div>

                    



                    <Link to={`/fiche-hebergement/${id}/${ressource}`} className={`${Style.LienFiche}`}>
                    {t('voir_fiche')}
                    </Link>
                    <div className={Style.DesktopFormField}>
                        <div className={Style.InputContainer}>
                            <div className={Style.Label}>
                                <img
                                    src={calendar}
                                    alt='calendar'
                                    className={Style.AccountIcon}
                                />
                                {startDate} - {endDate}
                                </div>
                            <div className={Style.Data}>{t('arrival')} : {formatTime(FicheHebergementData?.heure_arrivee)}</div>
                            <div className={Style.Data}>{t('departure')} : {formatTime(FicheHebergementData?.heure_depart)}</div>
                        </div>
                    </div>
                    <div className={Style.DesktopFormField}>
                        <div className={Style.InputContainer}>
                            <div className={Style.Label}>
                                <img
                                    src={pin}
                                    alt='pin'
                                    className={Style.AccountIcon}
                                />
                                {t('address')}
                            </div>
                            <div className={Style.Data}>Activital - Lac des Settons</div>
                            <div className={Style.Data}>58230 MONTSAUCHE LES SETTONS</div>
                        </div>
                        <div className={`${Style.InputContainer} ${Style.PeopleMargin}`}>
                            <div className={Style.Label}>
                                <img
                                    src={people}
                                    alt='people'
                                    className={Style.AccountIcon}
                                />
                                {t('traveler')}(s)
                            </div>
                            <div className={Style.Data}>{bookingData.nbAdults} {t('adults', { count: bookingData.nbAdults })} ({t('18')})</div>
                            <div className={Style.Data}>{bookingData.nbChilds} {t('children', { count: bookingData.nbChilds })} ({t('4')})</div>
                        </div>
                    </div>
                    {/*<div className={Style.DesktopFormField}>
                        <div className={Style.InputContainer}>
                            <div className={Style.Label}>
                                <img
                                    src={plus}
                                    alt='plus'
                                    className={Style.AccountIcon}
                                />
                                Option(s)
                            </div>
                        </div>
                    </div>*/}
                    <div className={Style.Separation}></div>
                    <div className={Style.Total}>
                        <div className={Style.Label}>{t('total')}</div>
                        <div className={Style.Price}>{totalPrice} €</div>
                    </div>
                </div>
            </form>
            <Box className={Style.AccountBox}>
                    <List>
                        <ListItem
                            className={Style.Button}
                            component={Link}
                            to={`/check-in/${ressource}/${asterioId}/${id}`}>
                            <div className={Style.Subtitle}>
                                <div>{t('entree')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                        <ListItem
                            className={Style.MiddleButton}
                            component={Link}
                            to={`/check-out/${ressource}/${asterioId}/${id}`}>
                            <div className={Style.Subtitle}>
                                <div>{t('sortie')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                        {/* <ListItem
                            className={Style.Button}
                            component={Link}
                            to=''>
                            <div className={Style.Subtitle}>
                                <div>{t('facture')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem> */}
                    </List>
                </Box>
        </div>
    )
}

export default BookingDetailPage
